var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.alerts),function(alert){return _c('alert-card',{key:alert.id,staticClass:"mb-4",attrs:{"alert":alert,"get-alerts":_vm.getAlerts}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }